// extracted by mini-css-extract-plugin
module.exports = {"card":"_3BNOYeO18uu5tYJQfKqKaA","header":"_1ANZNUgjnEjidC-CoEFh0I"};